import type { MessageKey } from './en';

export const am: Partial<Record<MessageKey, string>> = {
  'app.name': 'እድል',
  'app.tagline': 'የጊዜ ገደብ ያለው የእጣ ጨዋታ',
  'nav.lobby': 'ክፍሎች',
  'nav.raffle': 'ዕጣ',
  'nav.bingo': 'ቢንጎ',
  'nav.tickets': 'ትኬቶቼ',
  'nav.wallet': 'ቦርሳ',
  'nav.profile': 'መገለጫ',
  'nav.main': 'ዋና',
  'nav.account': 'የመለያ ማውጫ',
  'nav.section.play': 'ጨዋታ',
  'nav.section.money': 'ገንዘብ',
  'nav.section.account': 'መለያ',
  'common.loading': 'በመጫን ላይ…',
  'common.retry': 'እንደገና ይሞክሩ',
  'common.cancel': 'ይቅር',
  'common.confirm': 'አረጋግጥ',
  'common.save': 'አስቀምጥ',
  'common.close': 'ዝጋ',
  'common.back': 'ተመለስ',
  'common.offline': 'ከመስመር ውጭ ነዎት። የመጨረሻውን መረጃ እያሳየን ነው።',
  'common.live_paused': 'ቀጥታ ማሻሻያ ቆሟል፤ በየ5 ሰከንዱ እያደስን ነው።',
  'common.not_found': 'ገጹ አልተገኘም',
  'common.error_title': 'ችግር ተፈጥሯል',
  'common.offline_title': 'ከመስመር ውጭ ነዎት',
  'status.live': 'ቀጥታ',
  'status.reconnecting': 'እንደገና በመገናኘት ላይ',
  'auth.sign_in': 'ግባ',
  'auth.sign_out': 'ውጣ',
  'auth.register': 'መለያ ፍጠር',
  'auth.phone': 'ስልክ ቁጥር',
  'auth.password': 'የይለፍ ቃል',
  'auth.display_name': 'ስምዎ',
  'auth.dob': 'የትውልድ ቀን',
  'auth.confirm_age': 'ዕድሜዬ ቢያንስ {age} ዓመት ነው',
  'auth.accept_terms': 'ውሎቹን እና ኃላፊነት የተሞላበት የጨዋታ ደንቦችን እቀበላለሁ',
  'auth.no_account': 'ለእድል አዲስ ነዎት?',
  'auth.have_account': 'መለያ አለዎት?',
  'auth.with_telegram': 'በቴሌግራም ይቀጥሉ',
  'auth.forgot': 'የይለፍ ቃል ረሱ?',
  'auth.reset_sent': 'ይህ ቁጥር የተገናኘ የቴሌግራም መለያ ካለው፣ የማደሻ ሊንክ ልከናል።',
  'auth.reset_title': 'አዲስ የይለፍ ቃል ይምረጡ',
  'auth.reset_done': 'የይለፍ ቃል ተቀይሯል። እባክዎ ይግቡ።',
  'auth.new_password': 'አዲስ የይለፍ ቃል',
  'auth.sign_in_to_play': 'ትኬት ለመግዛት ይግቡ',
  'auth.invite_code': 'የግብዣ ኮድ (አማራጭ)',
  'auth.link_existing': 'በድረ-ገጹ የተከፈተ የእድል መለያ አለዎት? በምትኩ ይግቡ፤ ይህ የቴሌግራም መለያ ከእሱ ጋር ይገናኛል።',
  'auth.telegram_sub': 'በቴሌግራም መለያዎ ይገባሉ። የይለፍ ቃል አያስፈልግም።',
  'auth.use_password': 'በምትኩ ስልክ ቁጥርና የይለፍ ቃል ይጠቀሙ',
  'auth.telegram_failed': 'በቴሌግራም መግባት አልተሳካም። እድልን ዘግተው ከቦቱ እንደገና ይክፈቱ፣ ወይም ትንሽ ቆይተው እንደገና ይሞክሩ።',
  'auth.telegram_hint_web': 'በቴሌግራም ተመዝግበዋል? ከላይ ያለውን የቴሌግራም ቁልፍ ይጠቀሙ፣ ወይም የይለፍ ቃል ወደ ቴሌግራምዎ እንዲላክ “የይለፍ ቃል ረሱ?” ይንኩ።',
  'auth.welcome_back': 'እንኳን ደህና መጡ',
  'auth.sign_in_sub': 'ለመጫወት በስልክ ቁጥርዎ ይግቡ።',
  'auth.or': 'ወይም',
  'auth.create_title': 'መለያዎን ይፍጠሩ',
  'auth.browse_rooms': 'ክፍሎችን ይመልከቱ',
  'auth.brand_headline': 'ፍትሃዊ እጣ። እውነተኛ ሽልማት። በየጥቂት ደቂቃው።',
  'auth.point_fair': 'በማስረጃ ፍትሃዊ',
  'auth.point_live': 'ቀጥታ ውጤቶች',
  'auth.point_payout': 'በቴሌብር ክፍያ',
  'lobby.title': 'ክፍሎች',
  'lobby.draw_in': 'እጣ የሚወጣው በ',
  'lobby.sold': 'ከ{board} {sold} ተሽጧል',
  'lobby.first_prize': '1ኛ ሽልማት',
  'lobby.your_tickets': 'የእርስዎ {count}',
  'lobby.no_round': 'ቀጣዩ ዙር በቅርቡ ይከፈታል',
  'lobby.winners': 'የቅርብ አሸናፊዎች',
  'lobby.winner_line': '{name} በ{room} {amount} አሸነፉ',
  'lobby.eyebrow': 'የጊዜ ገደብ ያለው እጣ',
  'lobby.description': 'ክፍል ይምረጡ፣ ቁጥሮችዎን ይምረጡ እና እጣውን በቀጥታ ይመልከቱ።',
  'lobby.next_draw': 'ቀጣይ እጣ · {room}',
  'lobby.live_pools': 'የአሁኑ የሽልማት ገንዳዎች',
  'lobby.my_active': 'ንቁ ትኬቶችዎ',
  'lobby.rooms': 'ክፍሎች',
  'lobby.per_ticket': 'ለአንድ ትኬት',
  'lobby.board_of': 'ቁጥሮች 1–{size}',
  'lobby.sold_short': 'ተሽጧል',
  'lobby.min': 'ዝቅተኛ {min}',
  'lobby.always_draws': 'ሁልጊዜ እጣ ይወጣል',
  'lobby.play': 'ይጫወቱ',
  'lobby.winners_sub': 'የቅርብ ጊዜ እጣዎች',
  'lobby.no_winners': 'እስካሁን አሸናፊ የለም',
  'lobby.up_to': 'እስከ {amount}',
  'lobby.potential_hint': 'ሁሉም ቁጥሮች ከተሸጡ',
  'room.pick': 'ቁጥሮችዎን ይምረጡ',
  'room.lucky_dip': 'በዕድል ምረጥልኝ',
  'room.basket': 'ምርጫዎችዎ',
  'room.clear': 'አጽዳ',
  'room.buy': '{count} ትኬት ግዛ',
  'room.confirm_title': 'ግዢውን ያረጋግጡ',
  'room.total': 'ጠቅላላ',
  'room.balance_after': 'ቀሪ ሂሳብ ከግዢ በኋላ',
  'room.bought': 'መልካም ዕድል! {count} አዲስ ትኬት አለዎት።',
  'room.cap': 'በአንድ ተጫዋች እስከ {max} ትኬት',
  'room.taken': 'ተወስዷል',
  'room.mine': 'የእርስዎ',
  'room.sales_closed': 'ሽያጭ ተዘግቷል። እጣው በቅርቡ ይወጣል…',
  'room.prizes': 'የአሁኑ ሽልማቶች',
  'room.chance': 'አንድ ትኬት የማሸነፍ ዕድል፦ {pct}',
  'room.min_note': 'እጣ ለመውጣት {min} ትኬቶች ያስፈልጋሉ፤ ካልሆነ ሁሉም ትኬቶች ተመላሽ ይደረጋሉ።',
  'room.house': 'ኤዲል ሃውስ',
  'room.house_fill_note': 'ጥቂት ሰዎች ቢጫወቱም ይህ ዙር እጣ ይወጣል፤ {fill} ትኬት ከተሸጠ ኤዲል ሃውስ የቀሩትን እስከ {min} ይገዛል።',
  'room.house_fill_rule': 'ተጫዋቾች ቢያንስ {fill} ነገር ግን ከ{min} ያነሱ ትኬቶችን ከገዙ፣ እጣው ሁልጊዜ እንዲወጣ ኤዲል ሃውስ የቀሩትን ትኬቶች ይገዛል። የኤዲል ሃውስ ትኬቶች በሰሌዳው ላይ ምልክት ይደረግባቸዋል፤ የሚያሸንፉት ገንዘብ ወደ ቤቱ ይመለሳል። የእያንዳንዱ ትኬት የማሸነፍ እድል ሙሉ በሆነ ዙር ካለው ጋር ተመሳሳይ ነው።',
  'room.house_fill_rule_named': 'ተጫዋቾች ቢያንስ {fill} ነገር ግን ከ{min} ያነሱ ትኬቶች ከገዙ፣ ዕጣው ሁልጊዜ እንዲወጣ እድል ሃውስ የቀሩትን ትኬቶች ይገዛል። የሃውስ ትኬቶች እዚህ እንደሌሎች ተጫዋቾች ይታያሉ፤ የማረጋገጫ ገጹ ይዘረዝራቸዋል፣ የሚያሸንፉትም ወደ ሃውስ ይመለሳል።',
  'room.rules': 'ደንቦች',
  'room.history': 'ያለፉ ዙሮች',
  'room.add_money': 'በቂ ሂሳብ የለም። ገንዘብ ያስገቡ',
  'room.selected': 'የተመረጠ',
  'room.your_ticket': 'የእርስዎ ትኬት',
  'room.pick_hint': 'ለመጨመር በሰሌዳው ላይ ቁጥሮችን ይንኩ።',
  'room.pick_short': 'ቁጥሮችን ይምረጡ',
  'room.selected_count': '{count} ተመርጠዋል',
  'room.pay': '{amount} ይክፈሉ',
  'room.tickets': 'ትኬቶች',
  'room.price_each': 'የአንድ ትኬት ዋጋ',
  'room.insufficient': 'ለዚህ ግዢ ሂሳብዎ በቂ አይደለም።',
  'room.next_round': 'ቀጣይ ዙር',
  'room.lucky_dip_hint': 'ነፃ ቁጥሮችን እኛ እንመርጥልዎታለን',
  'room.opens_at': 'ይህ ዙር ለቲኬት የሚከፈተው {when} ነው። ያኔ ቁጥሮችን መምረጥ ይችላሉ።',
  'room.no_round': 'በዚህ ክፍል አሁን የተከፈተ ዙር የለም። ቀጣዩ ዙር ሲዘጋጅ እዚህ ይታያል።',
  'room.prizes_grow': 'ሽልማቶች በእያንዳንዱ ትኬት ሽያጭ ያድጋሉ።',
  'room.buy_none': 'ትኬት ይግዙ',
  'room.pages': 'ቁጥሮች',
  'round.state.OPEN': 'ክፍት',
  'round.state.CLOSED': 'ሽያጭ ተዘግቷል',
  'round.state.REFUNDED': 'ተመላሽ ተደርጓል',
  'round.state.RESTARTED': 'እንደገና ተጀምሯል',
  'round.state.SETTLED': 'ተጠናቋል',
  'round.drawing': 'አሸናፊዎች እየወጡ ነው…',
  'round.results': 'ውጤቶች',
  'round.you_won': '{amount} አሸንፈዋል!',
  'round.refunded_note': 'በቂ ትኬት ስላልተሸጠ ሁሉም ትኬቶች ተመላሽ ተደርገዋል።',
  'round.restarted_note': 'በዚህ ዙር ምንም ትኬት ስላልተሸጠ አዲስ ዙር ተጀምሯል።',
  'round.verify': 'ይህን እጣ ያረጋግጡ',
  'round.place': '{place} ደረጃ',
  'round.winners': 'አሸናፊዎች',
  'round.pool': 'የሽልማት ገንዳ',
  'round.fairness': 'ፍትሃዊነት',
  'verify.title': 'ይህን ዙር ያረጋግጡ',
  'verify.ok': 'ተረጋግጧል፦ ይህ እጣ ፍትሃዊ ነበር።',
  'verify.eyebrow': 'በማስረጃ ፍትሃዊ',
  'tickets.title': 'ትኬቶቼ',
  'tickets.empty': 'እስካሁን ትኬት የለዎትም።',
  'tickets.status.WON': 'አሸንፏል',
  'tickets.status.LOST': 'አላሸነፈም',
  'tickets.status.REFUNDED': 'ተመላሽ ተደርጓል',
  'tickets.all': 'ሁሉም',
  'tickets.browse': 'ክፍሎችን ይመልከቱ',
  'wallet.title': 'ቦርሳ',
  'wallet.available': 'ያለ ሂሳብ',
  'wallet.held': 'በይደር ያለ',
  'wallet.history': 'ታሪክ',
  'wallet.add_money': 'ገንዘብ አስገባ',
  'wallet.empty': 'እስካሁን ምንም ግብይት የለም።',
  'wallet.type.REFERRAL_BONUS': 'የግብዣ ጉርሻ',
  'wallet.type.SIGNUP_BONUS': 'የእንኳን ደህና መጡ ጉርሻ',
  'wallet.type.DEPOSIT_BONUS': "የማስገቢያ ጉርሻ",
  'wallet.type.BONUS_FORFEIT': "ጉርሻ ተሰርዟል",
  'bonus.banner': 'የማስገቢያ ጉርሻ አለ · እስከ +{max}',
  'bonus.offer_title': "እስከ {max} የሚደርስ {pct}% የማስገቢያ ጉርሻ",
  'bonus.offer_title_tiers': "እስከ {max} የሚደርስ የማስገቢያ ጉርሻ",
  'bonus.offer_first': "በመጀመሪያው {min} ወይም ከዚያ በላይ ማስገቢያዎ",
  'bonus.offer_any': "በሚቀጥለው {min} ወይም ከዚያ በላይ ማስገቢያዎ",
  'bonus.ends_in': "የሚያበቃው በ",
  'bonus.preview': "+{bonus} ጉርሻ፤ በ{total} ይጫወታሉ",
  'bonus.below_min': "ጉርሻውን ለማግኘት ቢያንስ {min} ያስገቡ",
  'bonus.next_tier': "{bonus} ጉርሻ ለማግኘት {more} ተጨማሪ ያስገቡ",
  'bonus.terms': "ጉርሻውን ለማውጣት በ{days} ቀናት ውስጥ {wager} ይጫወቱ። ቀድመው ካወጡ ጉርሻው ይሰረዛል።",
  'bonus.blocked.BONUS_ACTIVE': "ይህን ለማግኘት አሁን ያለዎትን ጉርሻ ተጫውተው ይጨርሱ።",
  'bonus.blocked.PHONE_NOT_VERIFIED': "ይህን ጉርሻ ለማግኘት በመገለጫ ውስጥ ስልክ ቁጥርዎን ያረጋግጡ።",
  'bonus.on_approval': "ማስገቢያዎ ሲጸድቅ +{bonus} ጉርሻ",
  'bonus.card_title': "የእርስዎ ጉርሻ",
  'bonus.progress': "ከ{required} ውስጥ {wagered} ተጫውተዋል",
  'bonus.expires': "እስከ {when} ይክፈቱት",
  'bonus.completed': "ተከፍቷል፤ ማውጣት ይችላሉ",
  'bonus.withdraw_warning': "የ{bonus} ጉርሻዎ ገና አልተከፈተም (ቀሪ {remaining})። አሁን ካወጡ ይሰረዛል።",
  'bonus.forfeit_confirm': "ጉርሻዬን ሰርዝና አውጣ",
  'bonus.cta': "አሁን ያስገቡ",
  'bonus.paid_badge': "+{bonus} ጉርሻ",
  'bonus.limited': "የተወሰነ ቅናሽ፤ ቀድሞ ለመጣ",
  'bonus.missed.FIRST_DEPOSIT_ONLY': "ይህ ጉርሻ ለመጀመሪያ ማስገቢያ ብቻ ነው፤ እርስዎ ከዚህ በፊት አስገብተዋል። እንደተለመደው ገንዘብ ማስገባት ይችላሉ።",
  'bonus.missed.LIMIT_REACHED': "ይህን ጉርሻ ቀድመው አግኝተዋል። እንደተለመደው ገንዘብ ማስገባት ይችላሉ።",
  'bonus.missed.SOLD_OUT': "ይህ ጉርሻ አልቋል፤ ሁሉም ቦታዎች ተይዘዋል። እንደተለመደው ገንዘብ ማስገባት ይችላሉ።",
  'bonus.missed.BUDGET_SPENT': "ይህ ጉርሻ አልቋል። እንደተለመደው ገንዘብ ማስገባት ይችላሉ።",
  'bonus.missed.ENDED': "ይህ ጉርሻ ጊዜው አልፏል። እንደተለመደው ገንዘብ ማስገባት ይችላሉ።",
  'bonus.missed.BONUS_ACTIVE': "ይህን ለማግኘት አሁን ያለዎትን ጉርሻ ተጫውተው ይጨርሱ።",
  'bonus.missed.PHONE_NOT_VERIFIED': "ይህን ጉርሻ ለማግኘት በመገለጫ ውስጥ ስልክ ቁጥርዎን ያረጋግጡ።",
  'bonus.celebrate_title': "🎉 {pct}% ጉርሻ እያገኙ ነው!",
  'bonus.celebrate_title_plain': "🎉 ጉርሻ እያገኙ ነው!",
  'bonus.celebrate_sub': "ማስገቢያዎ ሲጸድቅ ይጨመራል፤ በ{total} ይጫወታሉ",
  'bonus.added_toast': "🎉 {bonus} ጉርሻ ወደ ቦርሳዎ ገብቷል!",
  'wallet.main': 'ዋና ሂሳብ',
  'wallet.points': "ኤዲል ኮይን",
  'wallet.free_points': "የዛሬውን ነጻ ኤዲል ኮይን ይውሰዱ",
  'wallet.free_points_done': "ነጻ ኤዲል ኮይን ተጨምሯል።",
  'wallet.type.FREEPLAY_GRANT': "ነጻ ኤዲል ኮይን",
  'wallet.withdraw': 'ገንዘብ ያውጡ',
  'invite.title': 'ጓደኞችን ይጋብዙ',
  'invite.text': 'ሊንክዎን ያጋሩ። ጓደኛዎ ተቀላቅሎ ቅናሹን ሲያሟላ ሽልማት ይከፈላል።',
  'invite.code': 'የግብዣ ኮድዎ',
  'invite.copy': 'ሊንኩን ቅዳ',
  'invite.copied': 'ሊንኩ ተቀድቷል።',
  'invite.share': 'አጋራ',
  'invite.share_telegram': 'በቴሌግራም አጋራ',
  'invite.joined': 'የተቀላቀሉ ጓደኞች',
  'invite.pending': 'በመጠባበቅ ላይ',
  'invite.rewarded': 'የተሸለሙ',
  'invite.earned': 'ያገኙት',
  'invite.reward_points': "{n} ኤዲል ኮይን",
  'invite.earned_value': "{cash} እና {points} ኤዲል ኮይን",
  'profile.title': 'መገለጫ',
  'profile.language': 'ቋንቋ',
  'profile.theme': 'ገጽታ',
  'profile.theme_dark': 'ጨለማ',
  'profile.theme_light': 'ብሩህ',
  'profile.theme_system': 'እንደ ስልኬ',
  'profile.support': "እገዛ እና ድጋፍ",
  'profile.support_text': "ጥያቄ አለዎት ወይስ በማስገቢያ፣ በማውጫ ወይም በጨዋታ ላይ ችግር ገጥሞዎታል? ቡድናችን በቴሌግራም ይመልሳል።",
  'profile.support_button': "ለ{handle} ይጻፉ",
  'profile.saved': 'ተቀምጧል።',
  'profile.payout': 'የክፍያ መለያዎች',
  'profile.payout_text': 'ገንዘብ የሚላከው ወደ ተቀመጠው የቴሌብር ቁጥርዎ ወይም የባንክ ሂሳብዎ ብቻ ነው። በእያንዳንዱ ጊዜ የትኛውን እንደሚፈልጉ ይመርጣሉ።',
  'profile.payout_save': 'አስቀምጥ',
  'profile.payout_edit': 'ቀይር',
  'profile.payout_remove': 'አስወግድ',
  'profile.payout_bank': 'የባንክ ሂሳብ',
  'profile.payout_bank_badge': 'ባንክ',
  'profile.payout_bank_pick': 'ባንክ',
  'profile.payout_bank_choose': 'ባንክዎን ይምረጡ',
  'profile.payout_account_number': 'የሂሳብ ቁጥር',
  'profile.payout_bank_name': 'በባንክ ሂሳቡ ላይ ያለው ስም',
  'profile.promotions': 'ከእድል ማስታወቂያዎችን እና ስጦታዎችን ላክልኝ',
  'profile.password_set_title': 'የይለፍ ቃል ያዘጋጁ',
  'profile.password_set_text': 'በቴሌግራም በራስ-ሰር ይገባሉ። በ edilgames.app ላይ በስልክ ቁጥርዎ ለመግባትም የይለፍ ቃል ያዘጋጁ።',
  'profile.password_change_title': 'የይለፍ ቃል',
  'profile.password_change_text': 'በ edilgames.app ላይ በስልክ ቁጥርዎ ለመግባት። ሲቀይሩት ከሌሎች መሣሪያዎች ይወጣሉ።',
  'profile.password_current': 'አሁን ያለው የይለፍ ቃል',
  'profile.link_first': 'ቁጥርዎን ለማረጋገጥ መጀመሪያ የቴሌግራም መለያዎን ከእድል ጋር ያገናኙ።',
  'profile.link_this_telegram': 'ይህን የቴሌግራም መለያ አገናኝ',
  'profile.telegram_linked_done': 'ቴሌግራም ተገናኝቷል። አሁን ቁጥርዎን በእድል ቦት ያረጋግጡ።',
  'profile.verify_in_bot': 'ቴሌግራምዎ ተገናኝቷል። የእድል ቦትን ይክፈቱ፣ /start ይላኩ እና «ስልክ ቁጥሬን አጋራ» ይንኩ፤ {phone} ይረጋገጣል።',
  'profile.open_bot': 'የእድል ቦትን ክፈት',
  'profile.account': 'መለያ',
  'profile.preferences': 'ምርጫዎች',
  'profile.verified': 'የተረጋገጠ',
  'profile.unverified': 'ያልተረጋገጠ',
  'phone_verify.title': 'ስልክዎን ያረጋግጡ',
  'phone_verify.cta': 'አሁን ያረጋግጡ',
  'phone_verify.later': 'በኋላ',
  'phone.share_title': 'ስልክ ቁጥርዎን ያጋሩ',
  'phone.share_body': 'እድል በቴሌግራም መለያዎ ላይ ያለውን ቁጥር ይጠቀማል፤ ወዲያውኑ ይረጋገጣል። አንድ ንክኪ ብቻ ነው።',
  'phone.share_button': 'ስልክ ቁጥር አጋራ',
  'phone.waiting': 'ቴሌግራምን በመጠበቅ ላይ…',
  'phone.shared': 'ስልክ ቁጥር ከቴሌግራም ተጨምሯል',
  'phone.declined': 'እዚህ ለመመዝገብ ስልክ ቁጥርዎን ማጋራት አለብዎት።',
  'phone.timeout': 'ቴሌግራም እስካሁን አልላከውም። ትንሽ ቆይተው እንደገና ይንኩ።',
  'phone.unsupported': 'ስልክ ቁጥርዎን ለማጋራት ቴሌግራምን ያዘምኑ፣ ወይም የእድል ቦትን ከፍተው «ስልክ ቁጥር አጋራ» ይንኩ።',
  'phone.gate': 'ትኬት ለመግዛትና ገንዘብ ለማስገባት ስልክ ቁጥርዎን ያጋሩ። ገንዘብ ማውጣት አይነካም።',
  'phone.verified': 'እናመሰግናለን፣ ስልክ ቁጥርዎ ተረጋግጧል።',
  'gift.eyebrow': 'የስጦታ ዕድል',
  'gift.reward': 'እያንዳንዱ ስጦታ',
  'gift.claim': 'ስጦታዬን ተቀበል',
  'gift.won_title': 'የእርስዎ ነው!',
  'gift.won_body': "{points} ኤዲል ኮይን ወደ መለያዎ ተጨምሯል። ለነጻ ትኬቶች ይጠቀሙበት።",
  'gift.play': 'አሁን ይጫወቱ',
  'gift.starts_in': 'በ{time} ውስጥ ይከፈታል። በዚህ ገጽ ላይ ይቆዩ፤ በራሱ ይከፈታል።',
  'gift.sold_out': 'ሁሉም ስጦታዎች ተወስደዋል። የሚቀጥለውን በቦቱ እና በቡድኑ ይጠብቁ!',
  'gift.closed': 'ጊዜው አልፎበታል',
  'gift.join_to_claim': 'ለመውሰድ እድልን ይቀላቀሉ',
  'gift.verified_only': 'የተረጋገጠ ስልክ ቁጥር ላላቸው ተጫዋቾች።',
  'gift.not_found': 'ይህ የስጦታ ሊንክ ትክክል አይደለም።',
  'share.win_button': 'ድሌን አጋራ',
  'share.win_text': '🎉 አሁን በእድል {amount} አሸነፍኩ! በኔ ሊንክ ይቀላቀሉና እርስዎም እድልዎን ይሞክሩ (21+)፦',
  'share.failed': 'ማጋራት አልተከፈተም። እባክዎ እንደገና ይሞክሩ።',
  'tgsignup.welcome': 'እንኳን ደህና መጡ፣ {name}!',
  'tgsignup.sub': 'በአንድ ንክኪ ይጀምሩ። እድል በቴሌግራም መለያዎ ላይ ያለውን ስልክ ቁጥር ይጠቀማል፣ ስለዚህ ወዲያውኑ ይረጋገጣል።',
  'tgsignup.confirm': 'ዕድሜዬ ቢያንስ {age} ዓመት ነው፣ እና ደንቦቹን እና የኃላፊነት ጨዋታ ህጎችን እቀበላለሁ',
  'tgsignup.share_join': 'ስልክ ያጋሩና ይቀላቀሉ',
  'tgsignup.join': 'እድልን ይቀላቀሉ',
  'tgsignup.phone_ready': 'ከቴሌግራም የመጣ ስልክ ቁጥር፦ {phone}',
  'tgsignup.invited': 'በግብዣ ኮድ {code} ተጋብዘዋል',
  'tgsignup.have_code': 'የግብዣ ኮድ አለዎት?',
  'tgsignup.use_bot': 'በቦቱ ውይይት ውስጥ ያጋሩ',
  'tgsignup.bot_hint': 'በቦቱ ውይይት ውስጥ “ስልክ ቁጥር አጋራ” የሚለውን ይንኩ፣ ከዚያ ወደዚህ ይመለሱ። ምዝገባው በራሱ ይጠናቀቃል።',
  'rg.footer': 'በኃላፊነት ይጫወቱ። ከ21 ዓመት በላይ ብቻ።',
  'rg.banner': 'እረፍት ላይ ነዎት። ትኬት መግዛትና ገንዘብ ማስገባት አይቻልም፤ ቀሪ ሂሳብዎን ማውጣት ይችላሉ።',
  'rg.title': 'ኃላፊነት የተሞላበት ጨዋታ',
  'rg.limits': 'ገደቦችዎ',
  'rg.no_limit': 'ገደብ የለም',
  'rg.set': 'አስቀምጥ',
  'rg.break': 'እረፍት ይውሰዱ',
  'rg.cool_off': 'ጊዜያዊ እረፍት',
  'rg.self_exclusion': 'ራስን ማግለል',
  'rg.period.24H': '24 ሰዓት',
  'rg.period.7D': '7 ቀን',
  'rg.period.30D': '30 ቀን',
  'rg.period.6M': '6 ወር',
  'rg.period.1Y': '1 ዓመት',
  'rg.period.PERMANENT': 'በቋሚነት',
  'rg.start': 'እረፍት ጀምር',
  'rg.keep_playing': 'መጫወት ቀጥል',
  'rg.kind.DEPOSIT_DAILY': 'የዕለት ገቢ ገደብ',
  'rg.kind.DEPOSIT_WEEKLY': 'የሳምንት ገቢ ገደብ',
  'rg.kind.DEPOSIT_MONTHLY': 'የወር ገቢ ገደብ',
  'rg.kind.LOSS_DAILY': 'የዕለት ከሳራ ገደብ',
  'rg.kind.LOSS_WEEKLY': 'የሳምንት ከሳራ ገደብ',
  'rg.kind.LOSS_MONTHLY': 'የወር ከሳራ ገደብ',
  'rg.kind.SPEND_PER_ROUND': 'በአንድ ዙር የጨዋታ ገደብ',
  'rg.kind.SESSION_MINUTES': 'የጨዋታ ጊዜ ገደብ (በደቂቃ)',
  'loyalty.title': "ኤዲል ኮይን",
  'loyalty.points': "{points} ኤዲል ኮይን",
  'loyalty.text': "በሚጫወቱት እያንዳንዱ ብር {rate} ኤዲል ኮይን ያገኛሉ። ኤዲል ኮይንን ለነጻ ትኬቶች ይጠቀሙ፤ ወደ ገንዘብ አይቀየርም።",
  'loyalty.expiring': "{points} ኤዲል ኮይን እስከ {when} ጊዜው ያልፋል",
  'loyalty.pay_points': "{points} ኤዲል ኮይን ይጠቀሙ",
  'loyalty.redeemed': "ነጻ ትኬቶች ተጨምረዋል፣ በኤዲል ኮይን ተከፍሏል።",
  'notifications.title': 'ማሳወቂያዎች',
  'notifications.empty': 'እስካሁን ምንም ማሳወቂያ የለም።',
  'notifications.read_all': 'ሁሉንም እንደተነበቡ ምልክት አድርግ',
  'cashier.keep_balance': '{keep} ሁልጊዜ በሂሳብዎ ውስጥ ይቆያል።',
  'cashier.deposit_first': 'ከእንኳን ደህና መጡ ጉርሻ ያሸነፉትን ለማውጣት የመጀመሪያ ገንዘብዎን ያስገቡ።',
  'cashier.no_payout': 'ገንዘብ ከማውጣትዎ በፊት በመገለጫዎ ውስጥ የቴሌብር ቁጥር ወይም የባንክ ሂሳብ ያስገቡ።',
  'cashier.requests': 'ገቢና ወጪ ጥያቄዎች',
  'cashier.deposit_title': 'በቴሌብር ገንዘብ ያስገቡ',
  'cashier.amount': 'መጠን (ብር)',
  'cashier.continue': 'ቀጥል',
  'cashier.pay_title': 'ገንዘቡን በቴሌብር ይላኩ',
  'cashier.send_to': 'የቴሌብር ቁጥር',
  'cashier.holder': 'የሂሳቡ ስም',
  'cashier.exact_amount': 'ትክክለኛ መጠን',
  'cashier.reference': 'መለያ ኮድ',
  'cashier.time_left': 'የቀረው ጊዜ',
  'cashier.copy': 'ቅዳ',
  'cashier.copied': 'ተቀድቷል',
  'cashier.step1': 'ቴሌብርን በመክፈት «ገንዘብ ላክ» የሚለውን ይምረጡ።',
  'cashier.step2': 'ከላይ ያለውን ቁጥር ያስገቡ እና የስሙ ባለቤት «{name}» መሆኑን ያረጋግጡ።',
  'cashier.step3': 'ትክክለኛውን {amount} ይላኩ። ቴሌብር ከፈቀደ «{reference}» የሚለውን መለያ ቁጥር በምክንያት ቦታ ላይ ያስገቡ።',
  'cashier.step4': 'የማረጋገጫ ኤስኤምኤስ ያስቀሩ ወይም የደረሰኙን ቅጽበታዊ ገጽ እይታ (ስክሪንሾት) ያንሱ።',
  'cashier.i_paid': 'ከፍያለሁ',
  'cashier.proof_title': 'ክፍያዎን ያረጋግጡ',
  'cashier.txn_id': 'የቴሌብር ግብይት ቁጥር',
  'cashier.sender_number': 'የከፈሉበት ቁጥር',
  'cashier.screenshot': 'የደረሰኙ ቅጽበታዊ ገጽ እይታ',
  'cashier.choose_screenshot': 'ቅጽበታዊ ገጽ እይታውን ለመምረጥ ይንኩ',
  'cashier.submit_proof': 'ለግምገማ ላክ',
  'cashier.submitted_title': 'ክፍያው ተልኳል',
  'cashier.done': 'ተጠናቋል',
  'cashier.withdraw_title': 'ገንዘብ ያውጡ',
  'cashier.pin': 'ፒን',
  'cashier.request_withdrawal': 'ገንዘብ ማውጣት ጠይቅ',
  'cashier.deposit': 'ገቢ',
  'cashier.withdrawal': 'ወጪ',
  'cashier.state.AWAITING_PAYMENT': 'ክፍያ በመጠበቅ ላይ',
  'cashier.state.SUBMITTED': 'በግምገማ ላይ',
  'cashier.state.NEEDS_INFO': 'እርምጃ ያስፈልጋል',
  'cashier.state.PENDING_SECOND_APPROVAL': 'በግምገማ ላይ',
  'cashier.state.APPROVED': 'ጸድቋል',
  'cashier.state.REJECTED': 'አልጸደቀም',
  'cashier.state.EXPIRED': 'ጊዜው አልፏል',
  'cashier.state.REQUESTED': 'ተጠይቋል',
  'cashier.state.PAID': 'ተከፍሏል',
  'cashier.state.CANCELLED': 'ተሰርዟል',
  'cashier.state.FAILED': 'አልተሳካም',
  'bingo.title': 'ፈጣን ቢንጎ',
  'bingo.eyebrow': 'በድምፅ የሚጠራ · ማንኛውም መስመር ያሸንፋል',
  'bingo.lobby_sub': 'እስከ 4 ካርቴላ ይምረጡ፣ ከዚያ ኳሶቹን ያዳምጡ። መጀመሪያ መስመር የሞላ ያሸንፋል።',
  'bingo.per_cartela': 'ለአንድ ካርቴላ',
  'bingo.prize': 'አሸናፊው የሚያገኘው',
  'bingo.guaranteed': 'የተረጋገጠ · ተጫዋቾች ሲበዙ ያድጋል',
  'bingo.guaranteed_from': '{n} ተጫዋቾች ሲቀላቀሉ የተረጋገጠ',
  'bingo.players': '{players} ከ{min} ተጫዋቾች',
  'bingo.joined': '{players} ገብተዋል · {cartelas} ካርቴላ',
  'bingo.min_players': 'ቢያንስ {min} ተጫዋቾች',
  'bingo.starts_in': 'ይጀምራል በ',
  'bingo.waiting': 'ተጫዋቾችን በመጠበቅ ላይ',
  'bingo.state.OPEN': 'አሁን ይግቡ',
  'bingo.state.CALLING': 'በጨዋታ ላይ',
  'bingo.state.SETTLED': 'ተጠናቋል',
  'bingo.state.REFUNDED': 'ተመላሽ ተደርጓል',
  'bingo.play_now': 'አሁን ይጫወቱ',
  'bingo.watch_live': 'በቀጥታ ይመልከቱ',
  'bingo.guaranteed_short': 'የተረጋገጠ ሽልማት',
  'bingo.balls_short': '{count} ኳሶች',
  'bingo.cartelas_short': '{count} ካርቴላ',
  'bingo.round_info': 'ስለዚህ ዙር',
  'bingo.pick_now': 'ሊዘጋ ነው — ካርቴላዎን አሁን ይምረጡ!',
  'bingo.extended_flash': 'ተጨማሪ ጊዜ ተሰጥቷል — ተጫዋቾች እየገቡ ነው',
  'bingo.play': 'ይግቡ',
  'bingo.pick': 'ካርቴላዎችዎን ይምረጡ',
  'bingo.your_cartelas': 'የእርስዎ ካርቴላዎች',
  'bingo.buy': '{count} ካርቴላ ይግዙ',
  'bingo.buy_now': '{count} ይግዙ · {amount}',
  'bingo.pick_short': 'ለመምረጥ ቁጥሮችን ይንኩ',
  'bingo.bought': '{count} ካርቴላ ተገዝቷል። መልካም ዕድል!',
  'bingo.bought_points': "{count} ካርቴላ(ዎች) ተጨምረዋል፣ በኤዲል ኮይን ተከፍሏል።",
  'bingo.points_balance': "{points} ኤዲል ኮይን አለዎት። የ10 ብር ካርቴላ {cost} ኤዲል ኮይን ያስከፍላል።",
  'bingo.points_short': "🪙 {points}",
  'bingo.cartela_no': 'ካርቴላ ቁ. {n}',
  'bingo.current_ball': 'የአሁኑ ኳስ',
  'bingo.called_board': 'የተጠሩ ቁጥሮች',
  'bingo.get_ready': 'ይዘጋጁ…',
  'bingo.one_to_go': 'አንድ ቁጥር ብቻ ቀረ!',
  'bingo.bingo': 'ቢንጎ!',
  'bingo.you_won': '{amount} አሸንፈዋል!',
  'bingo.winners': 'አሸናፊዎች',
  'bingo.house': 'እድል ቤት',
  'bingo.next_round': 'ቀጣይ ዙር',
  'bingo.refunded': 'በቂ ተጫዋቾች ስላልገቡ ሁሉም ካርቴላዎች ተመላሽ ተደርገዋል።',
  'bingo.rules': 'እንዴት ይሠራል',
  'bingo.verify': 'ይህን ጨዋታ ያረጋግጡ',
  'bingo.recent': 'የቅርብ ጊዜ ጨዋታዎች',
  'bingo.pages': 'የካርቴላ ቁጥሮች',
  'bingo.go_to': 'ወደ ካርቴላ ቁ.',
  'bingo.go': 'ሂድ',
  'bingo.recent_sub': 'የተጠሩትን ኳሶች ለማየትና ፍትሐዊነቱን ለማረጋገጥ ጨዋታ ይንኩ።',
  'bingo.history_meta': '{players} ተጫዋቾች · በ{balls}ኛው ኳስ ተሸንፏል',
  'bingo.history_meta_one': '1 ተጫዋች · በ{balls}ኛው ኳስ ተሸንፏል',
  'bingo.sound_on': 'ለድምፅ ይንኩ',
  'verify.house_numbers': 'የእድል ሃውስ ትኬቶች (ሃውስ ሙሌት)፦ {numbers}',
  'bingo.house_seats': 'የእድል ሃውስ ካርቴላዎች',
  'bingo.at_least': 'ቢያንስ',
  'bingo.guaranteed_min': 'የተረጋገጠ ዝቅተኛ · ተጫዋቾች ሲበዙ ያድጋል',
  'bingo.today_best': 'የዛሬ ትልቁ ድል፦ {amount}',
  'bingo.guaranteed_at_close': 'ሲዘጋ ቢያንስ {amount} የተረጋገጠ',
  'bingo.check.house_order': 'የእድል ሃውስ ካርቴላዎች የዙሩን ይፋዊ ቅደም ተከተል ይከተላሉ',
  'bingo.house_order_note': 'ነፃ ካርቴላዎችን የሚወስደው በዙሩ ይፋዊ ሃሽ በተወሰነ ቅደም ተከተል ነው።',
  'bingo.house_names_note': 'የሃውስ ወንበሮች በተጫዋች ስም ይታያሉ፤ የማረጋገጫ ገጹ ይዘረዝራቸዋል።',
};